<a [routerLink]="blogPost().path">
  <div class="blog-card">
    <div class="d-flex justify-content-center align-items-center badge">
      <p class="mb-0 pb-0">{{blogPost().read_time}} min read</p>
    </div>
    <img class="blog-image image center cover h-50" [src]="blogPost().blog_hero_image.url" [alt]="blogPost().blog_hero_image.alt" />
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center justify-content-between category-wrapper">
        <span class="title-secondary my-2">{{blogPost().category | uppercase}}</span>
        <span>{{blogPost().last_modified_date | date }}</span>
      </div>
      <div class="title-wrapper">
        <h3 class="mb-2">{{blogPost().blog_title}}</h3>
      </div>
    </div>
  </div>
  
</a>
